import { defineAsyncComponent } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { getAuthModal } from 'common/lazy-components.js'
import ModalWrapperVfm from 'core/components/VfmModal/ModalWrapperVfm.vue'
import { useModal, useVfm, useModalSlot } from 'vue-final-modal'

let loyaltyLadderModal

export function useVfmModals() {
  const route = useRoute()
  const router = useRouter()
  const vfm = useVfm()

  function createModal({
    title,
    component = null,
    modalId,
    props = {},
    isMaximized,
    isBigSize,
    position,
    horizontalAlign,
    actions,
    body,
    keepAlive = false,
    onClose,
    contentClass,
    contentTransition,
    overlayClass,
    overlayStyle,
    hideOverlay,
    persistent,
  }) {
    const modalOptions = {
      component: ModalWrapperVfm,
      keepAlive,
      attrs: {
        title,
        modalId,
        component,
        props,
        isMaximized,
        isBigSize,
        position,
        horizontalAlign,
        actions,
        body,
        contentClass,
        contentTransition,
        overlayClass,
        overlayStyle,
        hideOverlay,
        persistent,
        onClosed() {
          onClose && onClose()
          if (route.query.modal === modalId) {
            const newQuery = { ...route.query }
            delete newQuery.modal
            router.replace({ query: newQuery })
          }
        },
      },
    }

    if (component) {
      modalOptions.slots = {
        default: useModalSlot({
          component,
          attrs: { ...props },
        }),
      }
    }

    return useModal(modalOptions)
  }

  function closeAllModals() {
    return vfm.closeAll()
  }

  /*
    !!! Использование Фабрики createModal !!!

    Если нужно прокидывать какие-то параметры из-вне, то делаем через стрелочную функцию
    const myModal = (props = {}) => createModal({ modalId: 'uniqmodalId', title: ..., component: MyComponent, props })

    Если модальное окно не динамическое и все параметры зашиты изначально, то просто создаем ее через фабрику
    const myModal = createModal({ modalId: 'uniqmodalId', title: ..., component: MyComponent })
   */

  /*
    Импорт модальных окон

    Важные модальные окна лучше импортировать не асинхронно!
    Какие-то тяжелые модальные окна которые встречаются не часто можно импортировать так в createModal
    component: defineAsyncComponent(() => import('components/modals/MyModal.vue'))
   */

  function authModal(props = {}) {
    return createModal({
      modalId: 'authModal',
      component: getAuthModal(),
      props,
    })
  }

  const openGameModal = (props = {}) => {
    return createModal({
      modalId: 'openGameModal',
      component: defineAsyncComponent(() => import('components/games/OpenGame.vue')),
      props,
    })
  }

  const openLootboxModal = (props = {}) => {
    return createModal({
      modalId: 'openLootboxModal',
      component: defineAsyncComponent(() => import('components/lootbox/OpenLootboxModal.vue')),
      props,
      contentTransition: 'vfm-slide-down',
    })
  }

  const craftLootboxModal = (props = {}) => {
    return createModal({
      modalId: 'craftLootboxModal',
      component: defineAsyncComponent(() => import('components/lootbox/CraftLootboxModal.vue')),
      isBigSize: true,
      contentClass: 'craft-lootbox-modal-content',
      props,
    })
  }

  const lootboxAnimationModal = (props = {}) => {
    return createModal({
      modalId: 'lootboxAnimationModal',
      component: defineAsyncComponent(() => import('components/lootbox/LootboxAnimationModal.vue')),
      props,
      persistent: true,
      overlayClass: 'lootbox-animation-overlay',
    })
  }

  const activatePromocodeModal = createModal({
    modalId: 'activatePromocodeModal',
    component: defineAsyncComponent(() => import('components/modals/ActivatePromocode.vue')),
  })

  const searchModal = createModal({
    modalId: 'searchModal',
    component: defineAsyncComponent(() => import('components/search/SearchModal.vue')),
    isBigSize: true,
  })

  const searchProvidersModal = createModal({
    modalId: 'searchProvidersModal',
    component: defineAsyncComponent(() => import('components/providers/filter/SearchProvidersGames.vue')),
    isBigSize: true,
  })

  loyaltyLadderModal = createModal({
    modalId: 'loyaltyLadderModal',
    component: defineAsyncComponent(() => import('src/pages/loyalty/components/LoyaltyLadder/Index.vue')),
    horizontalAlign: 'right',
    keepAlive: true,
    props: {
      class: 'loyalty-modal',
    },
  })

  const messagesModal = (oppt = {}) => {
    return createModal({
      modalId: 'messagesModal',
      component: defineAsyncComponent(() => import('components/messages/MessagesModal.vue')),
      ...oppt,
      contentClass: 'messages-modal-content',
    })
  }

  const messageDetailsModal = (oppt = {}) => {
    return createModal({
      modalId: 'messageDetailsModal',
      component: defineAsyncComponent(() => import('components/messages/MessageDetailsModal.vue')),
      ...oppt,
    })
  }

  const verifyEmailOnRegModal = (props) => {
    return createModal({
      modalId: 'verifyEmailOnRegModal',
      component: defineAsyncComponent(() => import('components/auth/VerifyEmailOnReg.vue')),
      props,
    })
  }

  const telegramMiniAppModal = createModal({
    modalId: 'telegramMiniAppModal',
    component: defineAsyncComponent(() => import('components/modals/TelegramMiniAppModal.vue')),
    persistent: true,
  })
  const giftModal = createModal({
    modalId: 'giftModal',
    component: defineAsyncComponent(() => import('components/modals/PromotedBonusModal.vue')),
  })

  const promoPokerBlockedModal = createModal({
    modalId: 'promoPokerBlockedModal',
    component: defineAsyncComponent(() => import('components/modals/PromoPokerBlockedModal.vue')),
  })

  return {
    closeAllModals,
    authModal,
    openGameModal,
    openLootboxModal,
    craftLootboxModal,
    lootboxAnimationModal,
    activatePromocodeModal,
    searchModal,
    searchProvidersModal,
    loyaltyLadderModal,
    messagesModal,
    messageDetailsModal,
    verifyEmailOnRegModal,
    telegramMiniAppModal,
    giftModal,
    promoPokerBlockedModal,
  }
}
